export default __webpack_public_path__ + "static/4-e560a4c85860d60a807a7a0cd5daf7a8.png";